export type TimeEntryStatus = 0 | 1 | 2 | 3;

export const TIME_ENTRY_STATUS_LABELS: Record<number, string> = {
  0: 'Draft',
  1: 'Submitted',
  2: 'Approved',
  3: 'Rejected'
};

export interface TimeEntryDto {
  id: string;
  employeeId: string;
  projectId?: string;
  taskId?: string;
  issueId?: string;
  date: string;
  hours: number;
  description?: string;
  status: number;
  statusLabel?: string;
  isBillable?: boolean;
  startedAt?: string | null;
  endedAt?: string | null;
  isRunning?: boolean;
}

export interface CreateManualTimeEntryRequest {
  employeeId?: string;
  projectId?: string;
  taskId?: string;
  issueId?: string;
  date: string;
  hours: number;
  description?: string;
  isBillable?: boolean;
}

export interface StartTimerRequest {
  projectId?: string;
  taskId?: string;
  issueId?: string;
  description?: string;
}

export interface TimesheetDayDto {
  date: string;
  totalHours: number;
  entries: TimeEntryDto[];
}

export interface TimesheetDto {
  employeeId?: string;
  employeeName?: string;
  from?: string;
  to?: string;
  /** @deprecated alias — prefer from/to */
  fromDate?: string;
  toDate?: string;
  totalHours: number;
  billableHours?: number;
  nonBillableHours?: number;
  days: TimesheetDayDto[];
}

export interface TimeEntryListParams {
  page?: number;
  pageSize?: number;
  employeeId?: string;
  projectId?: string;
  taskId?: string;
  issueId?: string;
}

export type TimesheetPreset = 'day' | 'week' | 'month';
